import type React from 'react';
import type { FC } from 'react';

import { clsx } from 'clsx';

import type { CenterProps } from './types';

const Center: FC<React.PropsWithChildren<CenterProps>> = ({
  className,
  children,
  ...rest
}) => (
  <div
    className={clsx('flex items-center justify-center w-full', className)}
    {...rest}
  >
    {children}
  </div>
);

export default Center;
